(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sousleau-algae-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.algaeReady)return;
  root.dataset.algaeReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-algae-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches?.035:.09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.algae-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.algae-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.algae-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#algae-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.algae-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-algae-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-algae-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-amano-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.amanoReady)return;
  root.dataset.amanoReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-amano-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches?.035:.09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.amano-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.amano-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.amano-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#amano-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.amano-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-amano-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-amano-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-aquascape-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.aquascapeReady)return;
  root.dataset.aquascapeReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-aquascape-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches ? .035 : .09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.aquascape-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.aquascape-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.aquascape-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#aquascape-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.aquascape-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-aquascape-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-aquascape-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-b2b-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  const quantity = value => {
    if (value === '' || value === null || typeof value === 'boolean') return null;
    const n = Number(value);
    return Number.isSafeInteger(n) && n >= 0 && n <= 999 ? n : null;
  };
  const priceLine = (offer, count) => {
    const packs = offer.kind === 'elemental' ? Math.floor(count / 6) : count;
    const singles = offer.kind === 'elemental' ? count % 6 : 0;
    return {
      packs, singles,
      total: offer.kind === 'elemental' ? packs * offer.sixPrice + singles * offer.price : count * offer.price,
      units: count * offer.unitsPerPack
    };
  };
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    let offers, labels;
    try {
      offers = JSON.parse(root.querySelector('[data-b2b-catalogue]').textContent);
      labels = JSON.parse(root.querySelector('[data-b2b-labels]').textContent);
    } catch { return; }
    const refs = new Map(offers.map(offer => [offer.id, offer]));
    const mode = root.dataset.mode;
    const ready = root.dataset.ready === 'true';
    const key = 'sousleau:wholesale-packs:v1:' + root.dataset.owner;
    const money = cents => new Intl.NumberFormat(root.dataset.locale === 'fr' ? 'fr-CA' : 'en-CA', {style:'currency',currency:'CAD'}).format(cents / 100);
    const format = (key, values = {}) => Object.entries(values).reduce((s, [k,v]) => s.replaceAll('{' + k + '}', String(v)), labels[key] || key);
    const linesHost = root.querySelector('[data-b2b-lines]');
    const error = root.querySelector('[data-b2b-error]');
    const review = root.querySelector('[data-b2b-review]');
    const submit = root.querySelector('[data-b2b-submit]');
    const body = root.querySelector('[data-b2b-body]');
    const draft = new Map();
    let storageOK = true;
    let valid = false;
    let submitted = false;
    let filter = 'all';
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved?.version === 1 && Array.isArray(saved.lines)) {
        for (const line of saved.lines) {
          const n = quantity(line.quantity);
          if (refs.get(line.id)?.enabled && n !== null && n > 0 && !draft.has(line.id)) draft.set(line.id, n);
        }
      }
    } catch { storageOK = false; }
    const success = root.querySelector('[data-b2b-success]');
    if (success) {
      draft.clear();
      try { sessionStorage.removeItem(key); } catch { storageOK = false; }
      success.focus();
    }
    function persist() {
      try {
        sessionStorage.setItem(key, JSON.stringify({version:1, lines:[...draft].map(([id,quantity]) => ({id,quantity}))}));
        storageOK = true;
      } catch { storageOK = false; }
    }
    function update() {
      let total = 0, units = 0, validInputs = true;
      const summary = [];
      const fulfillment = new Map();
      for (const input of linesHost.querySelectorAll('[data-b2b-quantity]')) {
        const offer = refs.get(input.dataset.b2bQuantity);
        const count = quantity(input.value);
        const row = input.closest('[data-b2b-card]');
        const lineTotal = row.querySelector('[data-b2b-line-total]');
        const breakdown = row.querySelector('[data-b2b-breakdown]');
        lineTotal.hidden = true;
        lineTotal.textContent = '';
        breakdown.hidden = true;
        breakdown.textContent = '';
        const correct = count !== null && input.validity.valid;
        input.setAttribute('aria-invalid', correct ? 'false' : 'true');
        if (!correct) {
          validInputs = false;
          continue;
        }
        if (!offer.enabled || !ready) { draft.delete(offer.id); continue; }
        if (count > 0) draft.set(offer.id, count); else draft.delete(offer.id);
        const line = priceLine(offer, count);
        if (!count) continue;
        lineTotal.hidden = false;
        lineTotal.textContent = format('lineTotal', {total:money(line.total)});
        if (offer.kind === 'elemental') {
          breakdown.hidden = false;
          breakdown.textContent = format('breakdown',{packs:line.packs,singles:line.singles});
        }
        total += line.total;
        units += line.units;
        summary.push(`${offer.title} — ${offer.format} — ${count} ${offer.kind === 'elemental' ? labels.units : labels.case} — ${line.units} ${labels.units} — ${money(line.total)} CAD`);
        if (offer.kind === 'elemental') summary.push(format('breakdown',{packs:line.packs,singles:line.singles}));
        for (const component of offer.components) {
          const existing = fulfillment.get(component.variant) || {...component, quantity:0};
          existing.quantity += component.units * count;
          fulfillment.set(component.variant, existing);
        }
      }
      if (validInputs) persist();
      valid = ready && validInputs && units > 0 && storageOK;
      root.querySelector('[data-b2b-total]').textContent = units > 0 && validInputs ? money(total) : '—';
      root.querySelector('[data-b2b-count]').textContent = units > 0 ? format('selected', {count:units}) : labels.chooseQuantities;
      if (review) review.setAttribute('aria-disabled', valid ? 'false' : 'true');
      if (submit) submit.disabled = !valid || submitted;
      error.textContent = !storageOK ? labels.storage : !validInputs ? labels.invalid : '';
      error.hidden = !error.textContent;
      if (body) body.value = valid ? [
        'SOUSLEAU B2B — REQUEST / DEMANDE — CAD — tariff 2026-09-25',
        ...summary, '', `${labels.subtotal}: ${money(total)} CAD`, '',
        'CONTENU / CONTENTS:',
        ...[...fulfillment.values()].map(c => `${c.quantity} × ${c.name} — ${c.format} — Shopify variant ${c.variant}`),
        '', labels.requestNote
      ].join('\n') : '';
      return valid;
    }
    function applyFilter() {
      for (const card of linesHost.querySelectorAll('[data-b2b-card]')) {
        const offer = refs.get(card.dataset.b2bCard);
        card.hidden = filter !== 'all' && (filter === 'elemental' ? offer.kind !== 'elemental' : offer.kind === 'elemental');
      }
    }
    function render() {
      linesHost.replaceChildren();
      const visibleOffers = [...offers].sort((a,b) => (a.kind === 'mixed' ? -1 : b.kind === 'mixed' ? 1 : 0)).filter(offer => mode !== 'cart' || draft.has(offer.id));
      root.querySelector('[data-b2b-empty]').hidden = visibleOffers.length > 0;
      for (const offer of visibleOffers) {
        const card = node('article','sl-b2b-offers__card');
        card.dataset.b2bCard = offer.id;
        if (offer.kind === 'mixed') {
          const images = node('div','sl-b2b-offers__mixed');
          for (const component of offer.components) {
            const source = offers.find(o => o.components.length === 1 && o.components[0].variant === component.variant);
            if (source?.image) { const img=node('img'); img.src=source.image; img.alt=component.name; img.loading='lazy'; images.append(img); }
          }
          card.append(images);
        } else if (offer.image) {
          const img=node('img'); img.src=offer.image; img.alt=''; img.loading='lazy'; card.append(img);
        }
        card.append(node('h2','',offer.title),node('p','sl-note',offer.format));
        card.append(node('strong','sl-b2b-offers__price',offer.kind === 'elemental' ? format('elementalPrice',{single:money(offer.price),six:money(offer.sixPrice)}) : `${money(offer.price)} / ${labels.case} (${offer.unitsPerPack} ${labels.units})`));
        if (offer.kind === 'elemental') card.append(node('p','sl-note',labels.elementalRule));
        if (!offer.enabled) card.append(node('p','sl-note',labels.unavailable));
        const label=node('label','',offer.kind === 'elemental' ? labels.unitQuantity : labels.caseQuantity);
        const input=node('input');
        input.id=root.id+'-'+offer.id;
        label.htmlFor=input.id;
        input.type='number'; input.min='0'; input.max='999'; input.step='1'; input.inputMode='numeric'; input.value=String(draft.get(offer.id)||0);
        input.dataset.b2bQuantity=offer.id;
        input.disabled=!offer.enabled||!ready;
        const controls=node('div','sl-b2b-offers__quantity');
        for (const step of [-1,1]) {
          const button=node('button','',step<0?'−':'+');button.type='button';button.dataset.b2bStep=String(step);button.disabled=input.disabled;
          button.setAttribute('aria-label',`${step<0?'−':'+'} ${labels.quantity} — ${offer.title}`);
          if(step<0)controls.append(button,input);else controls.append(button);
        }
        const lineTotal=node('strong','sl-b2b-offers__line-total');lineTotal.dataset.b2bLineTotal='';
        const breakdown=node('p','sl-note');breakdown.dataset.b2bBreakdown='';
        card.append(label,controls,lineTotal,breakdown);
        const details=node('details','sl-b2b-offers__details');
        details.append(node('summary','',labels.productDetails),node('h3','',labels.contents));
        const contents=node('ul');
        for (const component of offer.components) contents.append(node('li','',`${component.units} × ${component.name} — ${component.format}`));
        details.append(contents);
        const addDescription=(host,id)=>{
          const template=root.querySelector(`template[data-b2b-product-details="${id}"]`);
          if(template)host.append(template.content.cloneNode(true));
        };
        if(offer.kind==='mixed'){
          for(const component of offer.components){
            const source=offers.find(o=>o.components.length===1&&o.components[0].variant===component.variant);
            if(!source)continue;
            const part=node('details','sl-b2b-offers__details');
            part.append(node('summary','',component.name));addDescription(part,source.id);details.append(part);
          }
        }else addDescription(details,offer.id);
        card.append(details);
        if (mode==='cart') {const remove=node('button','sl-b2b-offers__remove',labels.remove);remove.type='button';remove.dataset.b2bRemove=offer.id;card.append(remove);}
        linesHost.append(card);
      }
      update();applyFilter();
    }
    root.addEventListener('input',event=>{if(event.target.matches('[data-b2b-quantity]'))update();});
    root.addEventListener('change',event=>{if(mode==='cart'&&event.target.matches('[data-b2b-quantity]')&&quantity(event.target.value)===0)render();});
    root.addEventListener('click',event=>{
      const step=event.target.closest('[data-b2b-step]');
      if(step){const input=step.closest('[data-b2b-card]').querySelector('input');const n=quantity(input.value);input.value=String(Math.min(999,Math.max(0,(n===null?0:n)+Number(step.dataset.b2bStep))));update();if(mode==='cart'&&input.value==='0')render();}
      const remove=event.target.closest('[data-b2b-remove]');
      if(remove){draft.delete(remove.dataset.b2bRemove);persist();render();}
      const filterButton=event.target.closest('[data-b2b-filter]');
      if(filterButton){filter=filterButton.dataset.b2bFilter;for(const b of root.querySelectorAll('[data-b2b-filter]'))b.setAttribute('aria-pressed',String(b===filterButton));applyFilter();}
      if(event.target.closest('[data-b2b-review]')&&!update())event.preventDefault();
    });
    const form=root.querySelector('form');
    if(form)form.addEventListener('submit',event=>{
      if(submitted||!update()){event.preventDefault();return;}
      submitted=true;if(submit)submit.disabled=true;
    });
    window.addEventListener('pageshow',()=>{submitted=false;update();});
    render();
  }
  const scan=scope=>scope.querySelectorAll('[data-b2b-offers]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document));else scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-beginner-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.beginnerReady)return;
  root.dataset.beginnerReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-beginner-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches ? .035 : .09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.beginner-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.beginner-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.beginner-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#beginner-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.beginner-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-beginner-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-beginner-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-blackwater-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.blackwaterReady)return;
  root.dataset.blackwaterReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-blackwater-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches ? .035 : .09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.blackwater-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.blackwater-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.blackwater-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#blackwater-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.blackwater-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-blackwater-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-blackwater-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-fertilizer-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.fertilizerReady)return;
  root.dataset.fertilizerReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-fertilizer-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches ? .035 : .09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.fertilizer-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.fertilizer-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.fertilizer-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#fertilizer-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.fertilizer-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-fertilizer-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-fertilizer-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-guide-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.guideReady)return;
  root.dataset.guideReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-guide-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches?.035:.09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.guide-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.guide-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.guide-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#guide-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.guide-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-guide-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-guide-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-language-switch"] && !Shopify.designMode) return;
  try {
    class SousleauLanguageSwitch extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('submit',()=>{const input=this.querySelector('input[name="return_to"]');if(input)input.value=location.pathname+location.search+location.hash;});}
  }
  if(!customElements.get('sl-language-switch'))customElements.define('sl-language-switch',SousleauLanguageSwitch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-plant-editorial-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const button=event.target.closest('[data-plant-photo]');
  if(!button)return;
  const gallery=button.closest('.sl-plant-gallery');
  const image=gallery.querySelector('.sl-plant-gallery__main');
  image.src=button.dataset.plantPhoto;
  image.alt=button.dataset.plantAlt;
  gallery.querySelectorAll('[data-plant-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-plantcare-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.plantcareReady)return;
  root.dataset.plantcareReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-plantcare-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches ? .035 : .09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.plantcare-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.plantcare-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.plantcare-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#plantcare-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.plantcare-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-plantcare-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-plantcare-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-plantchoice-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.plantchoiceReady)return;
  root.dataset.plantchoiceReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-plantchoice-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches ? .035 : .09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.plantchoice-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.plantchoice-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.plantchoice-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#plantchoice-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.plantchoice-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-plantchoice-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-plantchoice-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-substrate-story"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(root){
  if(root.dataset.substrateReady)return;
  root.dataset.substrateReady='true';
  const form=root.querySelector('[data-substrate-calc]');
  if(form){const result=form.querySelector('[data-substrate-result]');const calculate=()=>{if(!form.checkValidity())return;const values=['length','width','front','rear'].map(name=>Number(form.elements.namedItem(name).value));const litres=values[0]*values[1]*(values[2]+values[3])/2000;result.textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:1}).format(litres)+' L';};form.addEventListener('submit',event=>{event.preventDefault();calculate();});calculate();}
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const small=window.matchMedia('(max-width: 749px)');
  const panels=[...root.querySelectorAll('[data-substrate-parallax]')];
  let ticking=false;
  function draw(){
   ticking=false;
   if(!root.isConnected){window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);return;}
   const h=window.innerHeight;
   panels.forEach(panel=>{const b=panel.getBoundingClientRect();if(b.bottom<-200||b.top>h+200)return;const limit=small.matches?16:48;const movement=reduced.matches?0:Math.max(-limit,Math.min(limit,(h/2-b.top-b.height/2)*(small.matches ? .035 : .09)));panel.style.setProperty('--am-y',movement.toFixed(2)+'px');});
  }
  function queue(){if(!ticking){ticking=true;window.requestAnimationFrame(draw);}}
  window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});reduced.addEventListener('change',queue);queue();
  root.querySelectorAll('.substrate-table').forEach(el=>{el.tabIndex=0;el.setAttribute('role','region');const cap=el.querySelector('caption');if(cap)el.setAttribute('aria-label',cap.textContent);});
  root.querySelectorAll('.substrate-contents a').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));root.querySelector('.substrate-contents details').open=false;if(target){if(target.tagName==='DETAILS')target.open=true;else target.focus({preventScroll:true});}}));
  root.querySelectorAll('a[href^="#substrate-source-"]').forEach(link=>link.addEventListener('click',()=>{const sources=root.querySelector('.substrate-sources');if(sources)sources.open=true;}));
 }
 document.querySelectorAll('[data-substrate-story]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-substrate-story]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sousleau-winter-packaging"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-winter-editorial-toggle]');
  if (!button) return;
  var panel = document.getElementById(button.getAttribute('aria-controls'));
  if (!panel) return;
  var opening = panel.hidden;
  panel.hidden = !opening;
  button.setAttribute('aria-expanded', String(opening));
  button.querySelector('[data-winter-editorial-label]').textContent = opening ? button.dataset.closeLabel : button.dataset.openLabel;
});
  } catch(e) { console.error(e); }
})();

})();
